import React, { useEffect, useState } from 'react';
import GetPrivateProducts from '../../../services/get-submissions';
import ProductSubmission from './../../../components/ProductSubmission';
import ProgressCircle from './../../../components/ProgressCircle';

export default function Submissions() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);

  async function loadContent() {
    setLoading(true);
    await GetPrivateProducts(0, setSubmissions);
    setLoading(false);
  }

  useEffect(() => {
    loadContent();
  }, []);

  return (
    <div className="container-sm p-4">
      <div style={{ maxWidth: 600, margin: 'auto' }}>
        {loading &&
          <div style={{ width: 'max-content', margin: 'auto' }}>
            <ProgressCircle />
          </div>}
        {submissions.length < 1 && !loading &&
          <h2 style={{ margin: 'auto', textAlign: 'center' }}>
            No more submissions to review!</h2>}

        {submissions.map((prod, index) => {
          return (
            <ProductSubmission
              prod={prod}
              refreshContent={loadContent}
              key={prod?.pid}
              pid={prod?.pid}
              category={prod?.category}
              subCategory={prod?.subCategory}
              price={prod?.price}
              size={prod?.size}
              brand={prod?.brand}
              color={prod?.color}
              discount={prod?.discount}
              colorName={prod?.colorName}
              description={prod?.description}
              photos={prod?.photos}
            />
          );
        })}
      </div>

      {/* <Pagination /> */}
    </div>
  );
}
